const URL = 'https://solaris-japan.myshopify.com/api/2024-07/graphql.json';

export const gql = (query, variables) => {
  return fetch(URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': '24bebb49f4ad0b95920362a248a62c6e',
    },
    body: JSON.stringify({ query, variables }),
  });
};

export default {
  gql,
};
